"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Results = void 0;
var Results = /** @class */ (function () {
    function Results() {
        this.patientResults = {};
        this.unfilteredResults = {};
        this.localIdPatientResultsMap = {};
        this.patientEvaluatedRecords = {};
    }
    Object.defineProperty(Results.prototype, "evaluatedRecords", {
        // Expose an evaluatedRecords array for backwards compatibility
        get: function () {
            return [].concat.apply([], Object.values(this.patientEvaluatedRecords));
        },
        enumerable: false,
        configurable: true
    });
    Results.prototype.recordPatientResults = function (patient_ctx, resultMap) {
        var _this = this;
        var p = patient_ctx.patient;
        // NOTE: From now on prefer getId() over id() because some data models may have an id property
        // that is not a string (e.g., FHIR) -- so reserve getId() for the API (and expect a string
        // representation) but leave id() for data-model specific formats.
        var patientId = typeof p.getId === 'function' ? p.getId() : p.id();
        // Record the results
        this.patientResults[patientId] = resultMap;
        // Record the local IDs
        this.localIdPatientResultsMap[patientId] = patient_ctx.getAllLocalIds();
        // Record the evaluatedRecords, merging with an aggregated array across all libraries
        this.patientEvaluatedRecords[patientId] = __spreadArray([], patient_ctx.evaluatedRecords, true);
        Object.values(patient_ctx.library_context).forEach(function (ctx) {
            var _a;
            (_a = _this.patientEvaluatedRecords[patientId]).push.apply(_a, ctx.evaluatedRecords);
        });
    };
    Results.prototype.recordUnfilteredResults = function (resultMap) {
        this.unfilteredResults = resultMap;
    };
    return Results;
}());
exports.Results = Results;
//# sourceMappingURL=results.js.map